<div *ngIf="!loading; else showSpinner">
  <plotly-plot
    [data]="graph.data"
    [layout]="graph.layout"
    [config]="graph.config"
  ></plotly-plot>
</div>

<ng-template #showSpinner>
  <ng-template #elseBlock>
    <div *ngIf="graph.data.length == 0; else showSpinner">
      No hay datos para mostrar en el periodo
    </div>
  </ng-template>

  <ng-template #showSpinner>
    <app-loading [loadingText]="'Cargando datos'"></app-loading>
  </ng-template>
</ng-template>
